import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"

export enum RealityCheckAssets {
    COOL = "RealityCheckCOOL",
    NOT_COOL = "RealityCheckNOT_COOL",
    COOL_SLOGAN_DEFAULT = "RealityCheckCOOL_SLOGAN_DEFAULT",
    COOL_SLOGAN_OPPOSITE = "RealityCheckCOOL_SLOGAN_OPPOSITE",
    COOL_SLOGAN_1 = "RealityCheckCOOL_SLOGAN_1",
    COOL_SLOGAN_2 = "RealityCheckCOOL_SLOGAN_2",
    COOL_SLOGAN_3 = "RealityCheckCOOL_SLOGAN_3",

    LIKED = "RealityCheckLIKED",
    NOT_LIKED = "RealityCheckNOT_LIKED",
    LIKED_SLOGAN_DEFAULT = "RealityCheckLIKED_SLOGAN_DEFAULT",
    LIKED_SLOGAN_OPPOSITE = "RealityCheckLIKED_SLOGAN_OPPOSITE",
    LIKED_SLOGAN_1 = "RealityCheckLIKED_SLOGAN_1",
    LIKED_SLOGAN_2 = "RealityCheckLIKED_SLOGAN_2",
    LIKED_SLOGAN_3 = "RealityCheckLIKED_SLOGAN_3",

    EXCITING = "RealityCheckEXCITING",
    NOT_EXCITING = "RealityCheckNOT_EXCITING",
    EXCITING_SLOGAN_DEFAULT = "RealityCheckEXCITING_SLOGAN_DEFAULT",
    EXCITING_SLOGAN_OPPOSITE = "RealityCheckEXCITING_SLOGAN_OPPOSITE",
    EXCITING_SLOGAN_1 = "RealityCheckEXCITING_SLOGAN_1",
    EXCITING_SLOGAN_2 = "RealityCheckEXCITING_SLOGAN_2",
    EXCITING_SLOGAN_3 = "RealityCheckEXCITING_SLOGAN_3",

    BACKGROUND = "RealityCheckBACKGROUND",

    DONE_BUTTON = "RealityCheckDONE_BUTTON",

    // Audio enum values below here
    INTRO_AUDIO = "RealityCheckINTRO_AUDIO",
    CLICK_SLOGAN = "RealityCheckCLICK_SLOGAN",
    VAPERS_NOT_COOL = "RealityCheckVAPERS_NOT_COOL",
    NOT_COOL_AUDIO = "RealityCheckNOT_COOL_AUDIO",
    COOL_SLOGAN_1AUDIO = "RealityCheckCOOL_SLOGAN_1AUDIO",
    COOL_SLOGAN_2AUDIO = "RealityCheckCOOL_SLOGAN_2AUDIO",
    COOL_SLOGAN_3AUDIO = "RealityCheckCOOL_SLOGAN_3AUDIO",
    NOT_LIKED_AUDIO = "RealityCheckNOT_LIKED_AUDIO",
    LIKED_SLOGAN_1AUDIO = "RealityCheckLIKED_SLOGAN_1AUDIO",
    LIKED_SLOGAN_2AUDIO = "RealityCheckLIKED_SLOGAN_2AUDIO",
    LIKED_SLOGAN_3AUDIO = "RealityCheckLIKED_SLOGAN_3AUDIO",
    NOT_EXCITING_AUDIO = "RealityCheckNOT_EXCITING_AUDIO",
    EXCITING_SLOGAN_1AUDIO = "RealityCheckEXCITING_SLOGAN_1AUDIO",
    EXCITING_SLOGAN_2AUDIO = "RealityCheckEXCITING_SLOGAN_2AUDIO",
    EXCITING_SLOGAN_3AUDIO = "RealityCheckEXCITING_SLOGAN_3AUDIO",

}

export function loadAssets(game: Phaser.Game) {
    game.load.image(RealityCheckAssets.COOL, CCUtils.asset("reality-check/cool.jpg"))
    game.load.image(RealityCheckAssets.NOT_COOL, CCUtils.asset("reality-check/not-cool.jpg"))
    game.load.image(RealityCheckAssets.COOL_SLOGAN_DEFAULT, CCUtils.asset("reality-check/cool-slogan-default.png"))
    game.load.image(RealityCheckAssets.COOL_SLOGAN_OPPOSITE, CCUtils.asset("reality-check/cool-slogan-opposite.png"))
    game.load.image(RealityCheckAssets.COOL_SLOGAN_1, CCUtils.asset("reality-check/cool-slogan1.png"))
    game.load.image(RealityCheckAssets.COOL_SLOGAN_2, CCUtils.asset("reality-check/cool-slogan2.png"))
    game.load.image(RealityCheckAssets.COOL_SLOGAN_3, CCUtils.asset("reality-check/cool-slogan3.png"))

    game.load.image(RealityCheckAssets.LIKED, CCUtils.asset("reality-check/liked.jpg"))
    game.load.image(RealityCheckAssets.NOT_LIKED, CCUtils.asset("reality-check/not-liked.jpg"))
    game.load.image(RealityCheckAssets.LIKED_SLOGAN_DEFAULT, CCUtils.asset("reality-check/liked-slogan-default.png"))
    game.load.image(RealityCheckAssets.LIKED_SLOGAN_OPPOSITE, CCUtils.asset("reality-check/liked-slogan-opposite.png"))
    game.load.image(RealityCheckAssets.LIKED_SLOGAN_1, CCUtils.asset("reality-check/liked-slogan1.png"))
    game.load.image(RealityCheckAssets.LIKED_SLOGAN_2, CCUtils.asset("reality-check/liked-slogan2.png"))
    game.load.image(RealityCheckAssets.LIKED_SLOGAN_3, CCUtils.asset("reality-check/liked-slogan3.png"))

    game.load.image(RealityCheckAssets.EXCITING, CCUtils.asset("reality-check/exciting.jpg"))
    game.load.image(RealityCheckAssets.NOT_EXCITING, CCUtils.asset("reality-check/not-exciting.jpg"))
    game.load.image(RealityCheckAssets.EXCITING_SLOGAN_DEFAULT, CCUtils.asset("reality-check/exciting-slogan-default.png"))
    game.load.image(RealityCheckAssets.EXCITING_SLOGAN_OPPOSITE, CCUtils.asset("reality-check/exciting-slogan-opposite.png"))
    game.load.image(RealityCheckAssets.EXCITING_SLOGAN_1, CCUtils.asset("reality-check/exciting-slogan1.png"))
    game.load.image(RealityCheckAssets.EXCITING_SLOGAN_2, CCUtils.asset("reality-check/exciting-slogan2.png"))
    game.load.image(RealityCheckAssets.EXCITING_SLOGAN_3, CCUtils.asset("reality-check/exciting-slogan3.png"))

    game.load.image(RealityCheckAssets.BACKGROUND, CCUtils.asset("reality-check/brickwall.jpg"))

    game.load.spritesheet(RealityCheckAssets.DONE_BUTTON, CCUtils.asset("reality-check/done-button.png"), 480, 186)

    game.load.audio(RealityCheckAssets.INTRO_AUDIO, CCUtils.asset("reality-check/audio/intro.mp3"))
    game.load.audio(RealityCheckAssets.CLICK_SLOGAN, CCUtils.asset("reality-check/audio/click-each-slogan.mp3"))
    game.load.audio(RealityCheckAssets.VAPERS_NOT_COOL, CCUtils.asset("reality-check/audio/vapers-not-cool.mp3"))
    game.load.audio(RealityCheckAssets.NOT_COOL_AUDIO, CCUtils.asset("reality-check/audio/not-cool.mp3"))
    game.load.audio(RealityCheckAssets.COOL_SLOGAN_1AUDIO, CCUtils.asset("reality-check/audio/cool1.mp3"))
    game.load.audio(RealityCheckAssets.COOL_SLOGAN_2AUDIO, CCUtils.asset("reality-check/audio/cool2.mp3"))
    game.load.audio(RealityCheckAssets.COOL_SLOGAN_3AUDIO, CCUtils.asset("reality-check/audio/cool3.mp3"))
    game.load.audio(RealityCheckAssets.NOT_LIKED_AUDIO, CCUtils.asset("reality-check/audio/not-liked.mp3"))
    game.load.audio(RealityCheckAssets.LIKED_SLOGAN_1AUDIO, CCUtils.asset("reality-check/audio/liked1.mp3"))
    game.load.audio(RealityCheckAssets.LIKED_SLOGAN_2AUDIO, CCUtils.asset("reality-check/audio/liked2.mp3"))
    game.load.audio(RealityCheckAssets.LIKED_SLOGAN_3AUDIO, CCUtils.asset("reality-check/audio/liked3.mp3"))
    game.load.audio(RealityCheckAssets.NOT_EXCITING_AUDIO, CCUtils.asset("reality-check/audio/not-exciting.mp3"))
    game.load.audio(RealityCheckAssets.EXCITING_SLOGAN_1AUDIO, CCUtils.asset("reality-check/audio/exciting1.mp3"))
    game.load.audio(RealityCheckAssets.EXCITING_SLOGAN_2AUDIO, CCUtils.asset("reality-check/audio/exciting2.mp3"))
    game.load.audio(RealityCheckAssets.EXCITING_SLOGAN_3AUDIO, CCUtils.asset("reality-check/audio/exciting3.mp3"))

}

export function turnSloganAssetIntoAudioAsset(asset: string) {
    return asset + "AUDIO"
}
